export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8333.5d1ffd99.jpg";